export const select2WithoutSearch = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2SearchFilter = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: 0
}

export const select2LocationOption = {
    placeholder: "",
    allowClear: true,
    width: 'auto',
    dropdownAutoWidth: true,
    minimumInputLength: 3,
    ajax: null
}
